import { Directive, Input } from '@angular/core'

@Directive({
  selector: 'img[src]',
  host: {
    '[src]': 'checkPath(src)',
    '(error)': 'onError()'
  }
})
export class DefaultImgDirective {
  @Input() src: string

  public defaultImg = 'assets/img/placeholder.png'

  public onError() {
    return this.src = this.defaultImg
  }

  public checkPath(src) {
    return src ? src : this.defaultImg
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/default-img/default-img.directive.ts